import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { MessageHelpEvent } from './message-help-events';

@Injectable({ providedIn: 'root' })
export class MessageHelpEventProvider extends DomainEventProvider<MessageHelpEvent> {}
